import { BREAK_KEY } from '@techchange/pm-specs';
import { NodeSelection } from 'prosemirror-state';

/**
 * Updates the attributes for the node at the given position.
 *
 * @param {Object} oldAttrs  The old attributes.
 * @param {Object} newAttrs  The new attributes.
 * @param {number} pos       The node position.
 *
 * @returns {boolean} Whether or not the command was successful.
 *
 */
export const updateNodeAttrs = (oldAttrs, newAttrs, pos) => {

	return (state, dispatch) => {

		const { tr } = state;

		const updatedAttrs = Object.assign({}, oldAttrs, newAttrs);

		// Update attributes and preserve selection
		tr.setNodeMarkup(pos, null, updatedAttrs);
		tr.setSelection(NodeSelection.create(tr.doc, pos));

		if (dispatch) {
			dispatch(tr);
		}

		return true;

	};

};

/**
 * Updates the attributes for the provided list of nodes.
 *
 * @param {Array}   nodes     The list of nodes to update, position included.
 * @param {Object}  newAttrs  The new attributes to apply to each node.
 *
 * @returns {boolean} Whether or not the command was successful.
 */
export const updateNodeAttrsBulk = (nodes, newAttrs) => {

	return (state, dispatch) => {

		const { tr } = state;

		nodes.forEach((node) => {

			const updatedAttrs = {
				...node.attrs,
				...newAttrs,
			};

			// Update attributes and preserve selection
			tr.setNodeMarkup(node.pos, null, updatedAttrs);

		});

		if (dispatch) {
			dispatch(tr);
		}

		return true;

	};

};

/**
 * Removes all marks from the current selection.
 *
 * @param {Object} state     The current editor state.
 * @param {Object} dispatch  The editor dispatch.
 *
 * @returns {boolean} Whether or not the command was successful.
 *
 */
export const removeFormatting = (state, dispatch) => {

	const { tr, selection: { from, to } } = state;

	tr.removeMark(from, to);

	if (dispatch) {

		dispatch(tr);

	}

	return true;

};

/**
 * Replaces current selection with a hard break node (i.e. a <br> tag).
 *
 * @param {Object} state     The current editor state.
 * @param {Object} dispatch  The editor dispatch.
 *
 * @returns {boolean} Whether or not the command was successful.
 *
 */
export const insertBreak = (state, dispatch) => {

	const { schema, tr } = state;

	const breakNodeType = schema.nodes[BREAK_KEY];

	const newBreakNode = breakNodeType.create();

	tr.replaceSelectionWith(newBreakNode);

	if (dispatch) {

		dispatch(tr);

	}

	return true;

};
